import { render, staticRenderFns } from "./PopoverBody.vue?vue&type=template&id=b3309c78&"
import script from "./PopoverBody.vue?vue&type=script&lang=js&"
export * from "./PopoverBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports